import { Controller } from '@tencent/workbench';
import { FORM_CONFIGS, SpinOptions } from './config';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { RowColSizeFeature } from './row-col-size-feature';

@Controller({ formItems: FORM_CONFIGS })
export class RowColSizeController {
    constructor(private readonly feature: RowColSizeFeature) {}

    @Form(FormItemName.CELL_HEIGHT, 'value')
    public getHeight(): number | IMultiDiffValue {
        const rolColHeightObj = { rolColHeight: this.feature.getTableColSize().height };
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.TABLE_ROW_COL_SIZE, rolColHeightObj);
    }

    @Form(FormItemName.CELL_HEIGHT, 'onChange')
    public changeHeight(value: number, from: NumberInputFrom): void {
        const { rolColHeight } = this.feature.getValidValue({ rolColHeight: value }, from, SpinOptions.max);
        this.feature.updateWidthOfTableRows(rolColHeight, from);
    }

    @Form(FormItemName.CELL_WIDTH, 'value')
    public getWidth(): number | IMultiDiffValue {
        const rolColWidthObj = { rolColWidth: this.feature.getTableColSize().width };
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.TABLE_ROW_COL_SIZE, rolColWidthObj);
    }

    @Form(FormItemName.CELL_WIDTH, 'onChange')
    public changeWidth(value: number, from: NumberInputFrom): void {
        const { rolColWidth } = this.feature.getValidValue({ rolColWidth: value }, from, SpinOptions.max);
        this.feature.updateWidthOfTableCols(rolColWidth, from);
    }
}
